<template>
  <div>
    <div class="page-header">
      <span class="back-link" @click="$emit('back')">← 返回</span>
    </div>

    <div class="edit-form">
      <div class="form-row">
        <label class="form-label">iOS开关</label>
        <div class="form-content">
          <RadioGroup v-model="formData.iosSwitch" type="button">
            <Radio :label="0">关闭</Radio>
            <Radio :label="1">开启</Radio>
          </RadioGroup>
        </div>
      </div>

      <div class="form-row align-top">
        <label class="form-label">iOS开放规则</label>
        <div class="form-content">
          <div class="rule-table">
            <div class="rule-header">
              <span class="col-index">序号</span>
              <span class="col-entry">三方支付开放入口</span>
              <span class="col-crowd">人群包</span>
              <span class="col-action"></span>
            </div>
            <div
              v-for="(rule, index) in formData.iosRules"
              :key="'ios-rule-' + index"
              class="rule-row"
            >
              <span class="col-index">{{ index + 1 }}</span>
              <span class="col-entry">
                <Select
                  v-model="rule.entryConfigKeys"
                  multiple
                  placeholder="请选择开放入口"
                  :class="{
                    'select-error': showRuleErrors && !rule.entryConfigKeys.length
                  }"
                >
                  <Option
                    v-for="item in entryOptions"
                    :key="
                      'ios-entry-' +
                      buildEntryConfigKey(item.entrySourceType, item.entryId)
                    "
                    :value="
                      buildEntryConfigKey(item.entrySourceType, item.entryId)
                    "
                  >
                    {{ item.entryName }}
                  </Option>
                </Select>
                <span
                  v-if="showRuleErrors && !rule.entryConfigKeys.length"
                  class="error-tip"
                >
                  请选择开放入口
                </span>
              </span>
              <span class="col-crowd">
                <Select
                  v-model="rule.crowdIds"
                  multiple
                  filterable
                  placeholder="请选择人群包"
                  :class="{
                    'select-error': showRuleErrors && !rule.crowdIds.length
                  }"
                >
                  <Option
                    v-for="item in iosCrowdList"
                    :key="'ios-crowd-' + item.id"
                    :value="item.id"
                  >
                    {{ item.name }}
                  </Option>
                </Select>
                <span
                  v-if="showRuleErrors && !rule.crowdIds.length"
                  class="error-tip"
                >
                  请选择人群包
                </span>
              </span>
              <span class="col-action">
                <Icon
                  type="md-trash"
                  size="18"
                  color="#ed4014"
                  style="cursor: pointer"
                  @click="removeRule('ios', index)"
                />
              </span>
            </div>
          </div>
          <div class="add-row" @click="addRule('ios')">+ 新增规则</div>

          <div class="platform-extra-section">
            <div class="subsection-title">支付方式配置</div>
            <Table
              :columns="methodColumns"
              :data="formData.iosPayMethods"
              style="overflow: visible;"
              border
              size="small"
              :draggable="true"
              @on-drag-drop="(from, to) => onDrag('ios', from, to)"
            >
              <template #sort>
                <span class="drag-handle">≡</span>
              </template>
              <template #method="{ index }">
                <Select
                  v-model="formData.iosPayMethods[index].payMethod"
                  size="small"
                  placeholder="请选择"
                  style="width: 100%"
                  :disabled="formData.iosPayMethods[index].payMethod === 0"
                  @on-change="(val) => onMethodChange('ios', index, val)"
                >
                  <Option
                    v-for="item in iosMethodOptions"
                    :key="'ios-method-' + item.dictValue"
                    :value="Number(item.dictValue)"
                    :disabled="isMethodUsed('ios', Number(item.dictValue), index)"
                  >
                    {{ item.dictName }}
                  </Option>
                </Select>
              </template>
              <template #provider="{ index }">
                <Select
                  v-model="formData.iosPayMethods[index].provider"
                  size="small"
                  placeholder="--"
                  style="width: 100%"
                  :disabled="formData.iosPayMethods[index].payMethod === 0"
                >
                  <Option
                    v-for="item in getFilteredProviders('ios', index)"
                    :key="'ios-provider-' + item.dictValue"
                    :value="Number(item.dictValue)"
                    :disabled="(
                      isWalletSelected('ios', index) && item.dictName !== 'PayPal'
                    ) || (
                      isAppleOrGooglePaySelected('ios', index) && item.dictName === 'PayPal'
                    )"
                  >
                    {{ item.dictName }}
                  </Option>
                </Select>
              </template>
              <template #isDefault="{ index }">
                <Radio
                  :value="formData.iosPayMethods[index].isDefault"
                  @on-change="setDefault('ios', index)"
                ></Radio>
              </template>
              <template #action="{ index }">
                <Icon
                  v-if="formData.iosPayMethods[index].payMethod !== 0"
                  type="md-trash"
                  size="18"
                  color="#ed4014"
                  style="cursor: pointer"
                  @click="removeMethod('ios', index)"
                />
              </template>
            </Table>
            <div
              v-if="formData.iosPayMethods.length < 6"
              class="add-row"
              @click="addMethod('ios')"
            >
              + 新增支付方式
            </div>
            <div class="pay-link-row">
              <span class="subsection-title subsection-title--inline">支付链路</span>
              <RadioGroup v-model="formData.iosPayLinkType" type="button">
                <Radio :label="0">聚合支付</Radio>
                <Radio :label="1">分步支付</Radio>
              </RadioGroup>
            </div>
          </div>
        </div>
      </div>

      <div class="form-row">
        <label class="form-label">安卓开关</label>
        <div class="form-content">
          <RadioGroup v-model="formData.androidSwitch" type="button">
            <Radio :label="0">关闭</Radio>
            <Radio :label="1">开启</Radio>
          </RadioGroup>
        </div>
      </div>

      <div class="form-row align-top">
        <label class="form-label">安卓开放规则</label>
        <div class="form-content">
          <div class="rule-table">
            <div class="rule-header">
              <span class="col-index">序号</span>
              <span class="col-entry">三方支付开放入口</span>
              <span class="col-crowd">人群包</span>
              <span class="col-action"></span>
            </div>
            <div
              v-for="(rule, index) in formData.androidRules"
              :key="'android-rule-' + index"
              class="rule-row"
            >
              <span class="col-index">{{ index + 1 }}</span>
              <span class="col-entry">
                <Select
                  v-model="rule.entryConfigKeys"
                  multiple
                  placeholder="请选择开放入口"
                  :class="{
                    'select-error': showRuleErrors && !rule.entryConfigKeys.length
                  }"
                >
                  <Option
                    v-for="item in entryOptions"
                    :key="
                      'android-entry-' +
                      buildEntryConfigKey(item.entrySourceType, item.entryId)
                    "
                    :value="
                      buildEntryConfigKey(item.entrySourceType, item.entryId)
                    "
                  >
                    {{ item.entryName }}
                  </Option>
                </Select>
                <span
                  v-if="showRuleErrors && !rule.entryConfigKeys.length"
                  class="error-tip"
                >
                  请选择开放入口
                </span>
              </span>
              <span class="col-crowd">
                <Select
                  v-model="rule.crowdIds"
                  multiple
                  filterable
                  placeholder="请选择人群包"
                  :class="{
                    'select-error': showRuleErrors && !rule.crowdIds.length
                  }"
                >
                  <Option
                    v-for="item in androidCrowdList"
                    :key="'android-crowd-' + item.id"
                    :value="item.id"
                  >
                    {{ item.name }}
                  </Option>
                </Select>
                <span
                  v-if="showRuleErrors && !rule.crowdIds.length"
                  class="error-tip"
                >
                  请选择人群包
                </span>
              </span>
              <span class="col-action">
                <Icon
                  type="md-trash"
                  size="18"
                  color="#ed4014"
                  style="cursor: pointer"
                  @click="removeRule('android', index)"
                />
              </span>
            </div>
          </div>
          <div class="add-row" @click="addRule('android')">+ 新增规则</div>

          <div class="platform-extra-section">
            <div class="subsection-title">支付方式配置</div>
            <Table
              :columns="methodColumns"
              :data="formData.androidPayMethods"
              border
              size="small"
              :draggable="true"
              style="overflow: visible;"
              @on-drag-drop="(from, to) => onDrag('android', from, to)"
            >
              <template #sort>
                <span class="drag-handle">≡</span>
              </template>
              <template #method="{ index }">
                <Select
                  v-model="formData.androidPayMethods[index].payMethod"
                  size="small"
                  placeholder="请选择"
                  style="width: 100%"
                  :disabled="formData.androidPayMethods[index].payMethod === 0"
                  @on-change="(val) => onMethodChange('android', index, val)"
                >
                  <Option
                    v-for="item in androidMethodOptions"
                    :key="'android-method-' + item.dictValue"
                    :value="Number(item.dictValue)"
                    :disabled="
                      isMethodUsed('android', Number(item.dictValue), index)
                    "
                  >
                    {{ item.dictName }}
                  </Option>
                </Select>
              </template>
              <template #provider="{ index }">
                <Select
                  v-model="formData.androidPayMethods[index].provider"
                  size="small"
                  placeholder="--"
                  style="width: 100%"
                  :disabled="formData.androidPayMethods[index].payMethod === 0"
                >
                  <Option
                    v-for="item in getFilteredProviders('android', index)"
                    :key="'android-provider-' + item.dictValue"
                    :value="Number(item.dictValue)"
                    :disabled="(
                      isWalletSelected('android', index) && item.dictName !== 'PayPal'
                    ) || (
                      isAppleOrGooglePaySelected('android', index) && item.dictName === 'PayPal'
                    )"
                  >
                    {{ item.dictName }}
                  </Option>
                </Select>
              </template>
              <template #isDefault="{ index }">
                <Radio
                  :value="formData.androidPayMethods[index].isDefault"
                  @on-change="setDefault('android', index)"
                ></Radio>
              </template>
              <template #action="{ index }">
                <Icon
                  v-if="formData.androidPayMethods[index].payMethod !== 0"
                  type="md-trash"
                  size="18"
                  color="#ed4014"
                  style="cursor: pointer"
                  @click="removeMethod('android', index)"
                />
              </template>
            </Table>
            <div
              v-if="formData.androidPayMethods.length < 6"
              class="add-row"
              @click="addMethod('android')"
            >
              + 新增支付方式
            </div>
            <div class="pay-link-row">
              <span class="subsection-title subsection-title--inline">支付链路</span>
              <RadioGroup v-model="formData.androidPayLinkType" type="button">
                <Radio :label="0">聚合支付</Radio>
                <Radio :label="1">分步支付</Radio>
              </RadioGroup>
            </div>
          </div>
        </div>
      </div>

      <div class="form-row">
        <label class="form-label">三方支付策略名称</label>
        <div class="form-content">
          <Input
            v-model="formData.name"
            placeholder="仅用于后台展示"
            style="width: 300px"
            :maxlength="150"
          />
        </div>
      </div>

      <div class="footer-actions">
        <Button type="success" :loading="saving" @click="handleSave">保存</Button>
        <Button @click="$emit('back')">取消</Button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  addStrategy,
  editStrategy,
  getStrategyInfo,
  getSwitchEntryOptions
} from '@/api/thirdParty'
import { getCrowdList } from '@/api/crowd'
import { getDictionaryList } from '@/api/dictionary'

const PAGE_ENTRY_SOURCE_TYPE = 1
const ENTRY_CONFIG_KEY_SEPARATOR = '__'

const createEmptyRule = () => ({
  entryConfigKeys: [],
  crowdIds: []
})

const createDefaultPayMethod = () => ({
  payMethod: 0,
  provider: '',
  isDefault: true
})

const createExtraPayMethod = () => ({
  payMethod: '',
  provider: '',
  isDefault: false
})

const normalizeOptionalNumber = (value) => {
  return value === 0 || (value !== null && value !== undefined && value !== '')
    ? Number(value)
    : ''
}

export default {
  name: 'SwitchEdit',
  props: {
    editId: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      saving: false,
      formData: {
        id: null,
        name: '',
        iosSwitch: 0,
        androidSwitch: 0,
        iosRules: [createEmptyRule()],
        androidRules: [createEmptyRule()],
        iosPayMethods: [createDefaultPayMethod()],
        androidPayMethods: [createDefaultPayMethod()],
        iosPayLinkType: 0,
        androidPayLinkType: 0
      },
      iosCrowdList: [],
      androidCrowdList: [],
      entryOptions: [],
      iosMethodOptions: [
        { dictValue: '0', dictName: '内购' },
        { dictValue: '1', dictName: '卡支付' },
        { dictValue: '2', dictName: 'Apple Pay' },
        { dictValue: '4', dictName: '钱包' }
      ],
      androidMethodOptions: [
        { dictValue: '0', dictName: '内购' },
        { dictValue: '1', dictName: '卡支付' },
        { dictValue: '3', dictName: 'Google Pay' },
        { dictValue: '4', dictName: '钱包' }
      ],
      providerOptions: [
        { dictValue: '0', dictName: 'Stripe' },
        { dictValue: '1', dictName: 'Antom' },
        { dictValue: '2', dictName: 'PayPal' }
      ],
      showRuleErrors: false
    }
  },
  computed: {
    methodColumns() {
      return [
        { title: '排序', slot: 'sort', width: 60, align: 'center' },
        { title: '序号', type: 'index', width: 60, align: 'center' },
        { title: '支付方式', slot: 'method', minWidth: 140 },
        { title: '支付服务商', slot: 'provider', minWidth: 180 },
        { title: '设为默认', slot: 'isDefault', width: 100, align: 'center' },
        { title: '删除', slot: 'action', width: 60, align: 'center' }
      ]
    }
  },
  watch: {
    editId: {
      immediate: true,
      handler(val) {
        if (val) {
          this.loadData(val)
        } else {
          this.resetForm()
        }
      }
    }
  },
  mounted() {
    this.fetchOptions()
    this.loadCrowdList()
  },
  methods: {
    resetForm() {
      this.formData = {
        id: null,
        name: '',
        iosSwitch: 0,
        androidSwitch: 0,
        iosRules: [createEmptyRule()],
        androidRules: [createEmptyRule()],
        iosPayMethods: [createDefaultPayMethod()],
        androidPayMethods: [createDefaultPayMethod()],
        iosPayLinkType: 0,
        androidPayLinkType: 0
      }
      this.showRuleErrors = false
    },
    async fetchOptions() {
      try {
        const [entryRes, iosMethodRes, androidMethodRes, providerRes] =
          await Promise.all([
            getSwitchEntryOptions(),
            getDictionaryList({ dictTopic: 'PAY_METHOD_TYPE_IOS' }),
            getDictionaryList({ dictTopic: 'PAY_METHOD_TYPE_ANDROID' }),
            getDictionaryList({ dictTopic: 'PAY_PROVIDER_TYPE' })
          ])
        this.entryOptions = (entryRes.data || []).map((item) =>
          this.normalizeEntryOption(item)
        )
      } catch (error) {
        console.error('获取三方支付配置选项失败', error)
      }
    },
    normalizeEntrySourceType(entrySourceType) {
      const normalizedValue = Number(entrySourceType)
      return Number.isNaN(normalizedValue)
        ? PAGE_ENTRY_SOURCE_TYPE
        : normalizedValue
    },
    normalizeEntryOption(item = {}) {
      return {
        ...item,
        entrySourceType: this.normalizeEntrySourceType(item.entrySourceType),
        entryId:
          item.entryId === null || item.entryId === undefined
            ? ''
            : String(item.entryId)
      }
    },
    async loadCrowdList() {
      try {
        const [iosRes, androidRes] = await Promise.allSettled([
          getCrowdList({ current: 1, size: 100000, deviceSys: '0,-1' }),
          getCrowdList({ current: 1, size: 100000, deviceSys: '1,-1' })
        ])
        if (iosRes.status === 'fulfilled') {
          this.iosCrowdList = iosRes.value.data.records || []
        }
        if (androidRes.status === 'fulfilled') {
          this.androidCrowdList = androidRes.value.data.records || []
        }
      } catch (error) {
        console.error('获取人群包列表失败', error)
      }
    },
    async loadData(id) {
      try {
        const { data } = await getStrategyInfo(id)
        if (!data) return
        this.formData = {
          id: data.id,
          name: data.name || '',
          iosSwitch: Number(data.iosSwitch || 0),
          androidSwitch: Number(data.androidSwitch || 0),
          iosRules: (data.iosRules || []).length
            ? data.iosRules.map((item) => this.normalizeRule(item))
            : [createEmptyRule()],
          androidRules: (data.androidRules || []).length
            ? data.androidRules.map((item) => this.normalizeRule(item))
            : [createEmptyRule()],
          iosPayMethods: this.normalizePayMethods(data.iosPayMethods),
          androidPayMethods: this.normalizePayMethods(data.androidPayMethods),
          iosPayLinkType: Number(data.iosPayLinkType || 0),
          androidPayLinkType: Number(data.androidPayLinkType || 0)
        }
      } catch (error) {
        this.$Message.error('获取策略详情失败')
      }
    },
    buildEntryConfigKey(entrySourceType, entryId) {
      return `${this.normalizeEntrySourceType(
        entrySourceType
      )}${ENTRY_CONFIG_KEY_SEPARATOR}${entryId}`
    },
    parseEntryConfigKey(value) {
      if (!value && value !== 0) return null
      const rawValue = String(value)
      if (!rawValue.includes(ENTRY_CONFIG_KEY_SEPARATOR)) {
        return {
          entrySourceType: PAGE_ENTRY_SOURCE_TYPE,
          entryId: rawValue
        }
      }
      const [entrySourceType, ...entryIdParts] = rawValue.split(
        ENTRY_CONFIG_KEY_SEPARATOR
      )
      if (!entryIdParts.length) return null
      return {
        entrySourceType: this.normalizeEntrySourceType(entrySourceType),
        entryId: entryIdParts.join(ENTRY_CONFIG_KEY_SEPARATOR)
      }
    },
    normalizeRule(rule = {}) {
      const entryConfigs =
        Array.isArray(rule.entryConfigs) && rule.entryConfigs.length
          ? rule.entryConfigs
          : (rule.entryPoints || []).map((entryPoint) => ({
              entrySourceType: PAGE_ENTRY_SOURCE_TYPE,
              entryId: String(entryPoint)
            }))
      return {
        entryConfigKeys: entryConfigs
          .map((item) =>
            this.buildEntryConfigKey(item.entrySourceType, item.entryId)
          )
          .filter(Boolean),
        crowdIds: rule.crowdIds || []
      }
    },
    buildRulePayload(rule = {}) {
      const entryConfigs = (rule.entryConfigKeys || [])
        .map((item) => this.parseEntryConfigKey(item))
        .filter(Boolean)
        .map((item) => ({
          entrySourceType: this.normalizeEntrySourceType(item.entrySourceType),
          entryId: String(item.entryId)
        }))
      return {
        entryConfigs,
        entryPoints: entryConfigs
          .map((item) => Number(item.entryId))
          .filter((item) => !Number.isNaN(item)),
        crowdIds: rule.crowdIds || []
      }
    },
    normalizePayMethods(payMethods = []) {
      if (!Array.isArray(payMethods) || !payMethods.length) {
        return [createDefaultPayMethod()]
      }
      return payMethods.map((item) => ({
        payMethod: normalizeOptionalNumber(item.payMethod),
        provider:
          normalizeOptionalNumber(item.payMethod) === 0
            ? ''
            : normalizeOptionalNumber(item.provider),
        isDefault: !!item.isDefault
      }))
    },
    buildPayMethodPayload(payMethods = []) {
      return payMethods.map((item) => {
        const payload = {
          payMethod: Number(item.payMethod),
          isDefault: !!item.isDefault
        }
        if (item.payMethod !== 0 && (item.provider === 0 || item.provider !== '')) {
          payload.provider = Number(item.provider)
        }
        return payload
      })
    },
    addRule(platform) {
      this.showRuleErrors = false
      if (platform === 'ios') {
        this.formData.iosRules.push(createEmptyRule())
      } else {
        this.formData.androidRules.push(createEmptyRule())
      }
    },
    removeRule(platform, index) {
      if (platform === 'ios') {
        this.formData.iosRules.splice(index, 1)
      } else {
        this.formData.androidRules.splice(index, 1)
      }
    },
    addMethod(platform) {
      const list =
        platform === 'ios'
          ? this.formData.iosPayMethods
          : this.formData.androidPayMethods
      if (list.length >= 6) {
        this.$Message.warning('最多添加6个支付方式')
        return
      }
      list.push(createExtraPayMethod())
    },
    removeMethod(platform, index) {
      const list =
        platform === 'ios'
          ? this.formData.iosPayMethods
          : this.formData.androidPayMethods
      if (list[index] && list[index].payMethod === 0) {
        this.$Message.warning('内购支付方式不可删除')
        return
      }
      const wasDefault = list[index] && list[index].isDefault
      list.splice(index, 1)
      if (wasDefault && list.length > 0) {
        this.$set(list[0], 'isDefault', true)
      }
    },
    setDefault(platform, index) {
      const list =
        platform === 'ios'
          ? this.formData.iosPayMethods
          : this.formData.androidPayMethods
      list.forEach((item, itemIndex) => {
        this.$set(item, 'isDefault', itemIndex === index)
      })
    },
    isMethodUsed(platform, value, currentIndex) {
      const list =
        platform === 'ios'
          ? this.formData.iosPayMethods
          : this.formData.androidPayMethods
      return list.some((item, index) => {
        return index !== currentIndex && item.payMethod === value
      })
    },
    onMethodChange(platform, index, value) {
      const list =
        platform === 'ios'
          ? this.formData.iosPayMethods
          : this.formData.androidPayMethods
      const methodOptions = platform === 'ios' ? this.iosMethodOptions : this.androidMethodOptions

      if (value === 0) {
        this.$set(list[index], 'provider', '')
      } else {
        const walletOption = methodOptions.find(item => item.dictName === '钱包')
        if (walletOption && value === Number(walletOption.dictValue)) {
          const paypalOption = this.providerOptions.find(item => item.dictName === 'PayPal')
          if (paypalOption) {
            this.$set(list[index], 'provider', Number(paypalOption.dictValue))
          }
        } else {
          const targetOption = methodOptions.find(item =>
            item.dictName === 'Apple Pay' || item.dictName === 'Google Pay'
          )
          if (targetOption && value === Number(targetOption.dictValue)) {
            const paypalOption = this.providerOptions.find(item => item.dictName === 'PayPal')
            if (paypalOption && list[index].provider === Number(paypalOption.dictValue)) {
              this.$set(list[index], 'provider', '')
            }
          }
        }
      }
      if (!list.some((item) => item.isDefault)) {
        this.$set(list[index], 'isDefault', true)
      }
    },
    isWalletSelected(platform, index) {
      const list =
        platform === 'ios'
          ? this.formData.iosPayMethods
          : this.formData.androidPayMethods
      const methodOptions = platform === 'ios' ? this.iosMethodOptions : this.androidMethodOptions
      const walletOption = methodOptions.find(item => item.dictName === '钱包')
      if (!walletOption) return false
      if (!list[index]) return false
      return list[index].payMethod === Number(walletOption.dictValue)
    },

    isAppleOrGooglePaySelected(platform, index) {
      const list =
        platform === 'ios'
          ? this.formData.iosPayMethods
          : this.formData.androidPayMethods
      const methodOptions = platform === 'ios' ? this.iosMethodOptions : this.androidMethodOptions
      const targetOption = methodOptions.find(item =>
        item.dictName === 'Apple Pay' || item.dictName === 'Google Pay'
      )
      if (!targetOption) return false
      if (!list[index]) return false
      return list[index].payMethod === Number(targetOption.dictValue)
    },
    getFilteredProviders(platform, index) {
      if (this.isAppleOrGooglePaySelected(platform, index)) {
        return this.providerOptions.filter(item => item.dictName !== 'PayPal')
      }
      if (this.isWalletSelected(platform, index)) {
        return this.providerOptions.filter(item => item.dictName === 'PayPal')
      }
      return this.providerOptions
    },
    onDrag(platform, from, to) {
      const list =
        platform === 'ios'
          ? this.formData.iosPayMethods
          : this.formData.androidPayMethods
      if (from === to || from < 0 || to < 0) return
      const moved = list.splice(from, 1)[0]
      list.splice(to, 0, moved)
    },
    validatePayMethods(payMethods, label) {
      if (!payMethods.length) {
        this.$Message.warning(`请至少配置一种${label}支付方式`)
        return false
      }
      let hasDefault = false
      for (const item of payMethods) {
        if (item.payMethod !== 0 && item.payMethod === '') {
          this.$Message.warning(`请选择${label}支付方式`)
          return false
        }
        if (item.payMethod !== 0 && item.provider === '') {
          this.$Message.warning(`请选择${label}支付服务商`)
          return false
        }
        if (item.isDefault) {
          hasDefault = true
        }
      }
      if (!hasDefault && payMethods.length) {
        this.$set(payMethods[0], 'isDefault', true)
      }
      return true
    },
    async handleSave() {
      if (!this.formData.name || !this.formData.name.trim()) {
        this.$Message.warning('请输入策略名称')
        return
      }

      const allRules = [...this.formData.iosRules, ...this.formData.androidRules]
      if (allRules.length) {
        const hasEmpty = allRules.some((item) => {
          return !item.entryConfigKeys.length || !item.crowdIds.length
        })
        if (hasEmpty) {
          this.showRuleErrors = true
          this.$Message.warning('请完成所有开放规则的填写')
          return
        }
      }
      this.showRuleErrors = false

      if (!this.validatePayMethods(this.formData.iosPayMethods, 'iOS')) {
        return
      }
      if (!this.validatePayMethods(this.formData.androidPayMethods, '安卓')) {
        return
      }

      this.saving = true
      try {
        const submitData = {
          id: this.formData.id,
          name: this.formData.name.trim(),
          iosSwitch: Number(this.formData.iosSwitch),
          androidSwitch: Number(this.formData.androidSwitch),
          iosRules: this.formData.iosRules.map((item) =>
            this.buildRulePayload(item)
          ),
          androidRules: this.formData.androidRules.map((item) =>
            this.buildRulePayload(item)
          ),
          iosPayMethods: this.buildPayMethodPayload(this.formData.iosPayMethods),
          androidPayMethods: this.buildPayMethodPayload(
            this.formData.androidPayMethods
          ),
          iosPayLinkType: Number(this.formData.iosPayLinkType || 0),
          androidPayLinkType: Number(this.formData.androidPayLinkType || 0)
        }

        if (this.editId) {
          submitData.id = this.editId
          await editStrategy(submitData)
        } else {
          delete submitData.id
          await addStrategy(submitData)
        }

        this.$Message.success('保存成功')
        this.$emit('back')
      } catch (error) {
        this.$Message.error('保存失败')
      } finally {
        this.saving = false
      }
    }
  }
}
</script>

<style scoped lang="less">
.page-header {
  padding-bottom: 15px;
  border-bottom: 1px solid #e8eaec;
  margin-bottom: 25px;
}

.back-link {
  font-size: 14px;
  color: #515a6e;
  cursor: pointer;

  &:hover {
    color: #2d8cf0;
  }
}

.edit-form {
  padding: 0 10px;
}

.form-row {
  display: flex;
  align-items: center;
  margin-bottom: 20px;

  &.align-top {
    align-items: flex-start;
  }
}

.form-label {
  width: 120px;
  text-align: right;
  margin-right: 15px;
  color: #515a6e;
  font-size: 14px;
  flex-shrink: 0;
}

.form-content {
  flex: 1;
  min-width: 0;
}

.rule-table {
  border: 1px solid #e8eaec;
  border-radius: 4px;
  overflow: hidden;
}

.rule-header {
  display: flex;
  align-items: center;
  background: #f8f8f9;
  border-bottom: 1px solid #e8eaec;
  padding: 8px 0;
  font-size: 13px;
  font-weight: 600;
  color: #515a6e;
}

.rule-row {
  display: flex;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #f0f0f0;

  &:last-child {
    border-bottom: none;
  }
}

.col-index {
  width: 50px;
  text-align: center;
  flex-shrink: 0;
}

.col-entry,
.col-crowd {
  flex: 1;
  padding: 0 8px;
}

.col-action {
  width: 40px;
  text-align: center;
  flex-shrink: 0;
}

.add-row {
  color: #2d8cf0;
  cursor: pointer;
  font-size: 13px;
  padding: 10px 0;

  &:hover {
    color: #57a3f3;
  }
}

.platform-extra-section {
  margin-top: 12px;
  padding-top: 16px;
  border-top: 1px dashed #e8eaec;
}

.subsection-title {
  display: block;
  margin-bottom: 10px;
  color: #515a6e;
  font-size: 14px;
  font-weight: 600;
}

.subsection-title--inline {
  margin-bottom: 0;
}

.pay-link-row {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 16px;
}

.drag-handle {
  font-size: 16px;
  color: #999;
  cursor: grab;
  user-select: none;
}

.select-error /deep/ .ivu-select-selection {
  border-color: #ed4014 !important;
}

.error-tip {
  display: block;
  color: #ed4014;
  font-size: 12px;
  line-height: 1.2;
  padding-top: 4px;
}

.footer-actions {
  display: flex;
  gap: 15px;
  margin-top: 30px;
  padding-top: 20px;
}
</style>